<template>
  <v-row justify="center">
    <v-dialog
      v-model="display"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card flat>
        <v-toolbar
          dark
          color="primary"
        >
          <v-btn
            icon
            dark
            @click="$emit('update:display', false)"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Объект {{ office.title }}</v-toolbar-title>
          <v-spacer />
        </v-toolbar>
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              Пользователи ({{ office && office.id ? office.managerList.length : 0 }})
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-data-table
                fixed-header
                :height="tableHeight"
                :items="office.managerList"
                :headers="userHeaders"
                hide-default-footer
                flat
              >
                <template v-slot:item.createdAt="{ item }">
                  {{ formatDate(item.createdAt) }}
                </template>
                <template v-slot:item.isActive="{ item }">
                  <v-icon :color="item.isActive ? 'success': 'error'">
                    {{ item.isActive ? 'mdi-check':`mdi-close` }}
                  </v-icon>
                </template>
              </v-data-table>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header>Активные офферы ({{ data.length }})</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-data-table
                fixed-header
                :height="tableHeight"
                :items="data"
                :headers="offerHeaders"
                :loading="tableLoading"
                :expanded.sync="expandedList"
                show-expand
                expand-icon="visibility"
                hide-default-footer
                singleExpand
                :server-items-length="getPaginator.total"
                :footer-props="{}"
                flat
                @item-expanded="onOfferClick"
              >
                <template v-slot:item.startAt="{ item }">
                  {{ `${item.startDate} ${item.startTime}` }}
                </template>
                <template v-slot:item.createdAt="{ item }">
                  {{ `${item.createdDate} ${item.createdTime}` }}
                </template>
                <template v-slot:item.endAt="{ item }">
                  {{ `${item.endDate} ${item.endTime}` }}
                </template>
                <template v-slot:item.respondList="{ item }">
                  {{ item.respondList.length }}
                </template>
                <template v-slot:item.invitationList="{ item }">
                  {{ item.invitationList.length }}
                </template>
                <template v-slot:item.relayList="{ item }">
                  {{ item.relayList.length }}
                </template>
                <template
                  v-slot:expanded-item="{ headers, item }"
                >
                  <td
                    :colspan="headers.length"
                    class="py-6"
                  >
                    <template>
                      <v-data-table
                        v-if="offer && offer.id"
                        fixed-header
                        :height="tableHeight"
                        style="background: #a9a9a93d"
                        :headers="respondHeaderList"
                        :loading="offerLoading"
                        :items="getChildrenView"
                        hide-default-footer
                        class="elevation-1"
                      >
                        <template v-slot:item.createdAt="{ item }">
                          {{ formatDate(item.createdAt) }}
                        </template>
                        <template v-slot:item.startedAt="{ item }">
                          {{ item.type === 'Смена' ? formatDate(item.startedAt) : formatDate(offer.startAt) }}
                        </template>
                        <template v-slot:item.endAt="{ item }">
                          {{ item.type === 'Смена' ? formatDate(item.endAt) : formatDate(offer.endAt) }}
                        </template>
                        <template
                          v-slot:item.laborer="{ item }"
                        >
                          <v-list-item class="px-2">
                            <v-list-item-avatar>
                              <v-img :src="item.laborer.avatar.path" />
                            </v-list-item-avatar>
                            <v-list-item-title>
                              <span style="display: block"> {{ item.laborer.fullName }}</span>
                              <span style="display: block; color: dimgrey"> {{ item.laborer.phone }}</span>
                            </v-list-item-title>
                          </v-list-item>
                        </template>
                        <template v-slot:item.options="{ item }">
                          <v-btn
                            v-if="item.status === 'accepted'"
                            rounded
                            small
                            color="success"
                            @click="createRelay(item)"
                          >
                            Создать смену
                          </v-btn>
                        </template>
                      </v-data-table>

                      <!--                <DataList-->
                      <!--                  :headers="respondHeaderList"-->
                      <!--                  :paginator="{total: 1000}"-->
                      <!--                  :hide-default-footer="true"-->
                      <!--                  :data="getChildren(item)"-->
                      <!--                  :loading="false"-->
                      <!--                />-->
                    </template>
                  </td>
                </template>
              </v-data-table>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import { formatDate } from '@/utils/date-util'
import RelayView from '@/mixins/relay-mixin.vue'

export default {
  name: 'OrganizationOfficeView',
  mixins: [RelayView],
  props: {
    display: {
      type: Boolean
    },
    data: {
      type: Array
    },
    office: {
      type: Object
    },
    tableLoading: {
      type: Boolean
    }
  },
  data () {
    return {
      notifications: false,
      expandedList: ['dc3911ca-2dda-4f33-b9a4-f98f0a0bd4b5'],
      sound: true,
      panel: 0,
      offer: null,
      currentRowData: null,
      widgets: false,
      offerLoading: false,
      respondHeaderList: [
        {
          text: 'Создано',
          align: 'left',
          sortable: false,
          value: 'createdAt',
        },
        {
          text: 'Статус',
          align: 'left',
          sortable: false,
          value: 'status',
        },
        { text: 'Тип', value: 'type', sortable: false },
        { text: 'Начало Смены', value: 'startedAt', sortable: false },
        { text: 'Конец Смены', value: 'endAt', sortable: false },
        { text: 'ЗП', value: 'pay', sortable: false },
        { text: 'исполнитель', value: 'laborer', sortable: false },
        { text: '', value: 'options' },
      ],
      userHeaders: [
        { text: 'Создан', value: 'createdAt', sortable: false },
        {
          text: 'ФИО',
          align: 'left',
          sortable: false,
          value: 'fullName',
        },
        { text: 'Телефон', value: 'telephone', sortable: false },
        { text: 'Активирован', value: 'isActive', sortable: false },
        { text: 'Почта', value: 'username', sortable: false },
      ],
      offerHeaders: [
        {
          text: 'Вакансия',
          align: 'left',
          sortable: false,
          value: 'vacancy.title',
        },
        { text: 'Создан', value: 'createdAt' },
        {
          text: 'Начало',
          align: 'left',
          sortable: false,
          value: 'startAt',
        },
        { text: 'Конец', value: 'endAt', sortable: false },
        { text: 'Исполнители', value: 'childrenNumber', sortable: false },
        { text: 'Отклики', value: 'respondNumber', sortable: false },
        { text: 'приглашения', value: 'invitationNumber', sortable: false },
        { text: 'Смены', value: 'relayNumber', sortable: false },
        { text: 'Ставка', value: 'costPerHour', sortable: false },
        { text: 'ФОТ', value: 'expense', sortable: false },
        { text: 'ЗП', value: 'pay', sortable: false },
      ],
    }
  },
  computed: {
    getChildrenView () {
      if (!this.offer) {
        return []
      }

      const laborerList = {}
      for (const respond of this.offer.respondList) {
        if (respond && respond.laborer) {
          laborerList[respond.laborer.id] = respond.laborer
        }
      }
      return [
        ...this.offer.relayList.map((item) => ({ ...item, type: 'Смена' })),
        ...this.offer.invitationList.map((item) => (
          { ...item, type: 'Приглашение' })
        ),
        ...this.offer.respondList.map((item) => ({ ...item, type: 'Отклик' })),
      ]
    },
    getPaginator () {
      // return this.$store.getters['project/getPaginator']
      return { total: 1000 }
    },
    getOfferList () {
      return this.$store.state.organization.officeList || []
    }
  }, methods: {
    createRelay (item) {
      // onOfferClick
      this.postRelay({
        'laborer': { 'id': item.laborer.id },
      },
      this.onOfferClick, this.currentRowData
      )
    },
    async onOfferClick (rowData, status) {
      let list = {
        relayList: [],
        invitationList: [],
        respondList: [],
      }
      this.currentRowData = rowData
      this.offer = rowData.item
      if (rowData.item && !!rowData.value) {
        this.offerLoading = true
        list = await this.$store.dispatch(
          'organization/getOfficeOffer',
          { groupToken: rowData.item.groupToken, id: rowData.item.id }
        )
        if (list.data && Array.isArray(list.data) && list.data.length) {
          delete list.data[0].id
          const offer = {
            ...rowData.item,
            ...list.data[0]
          }
          this.offer = offer
        }
        this.offerLoading = false
      }
    },
    formatDate (date, format = 'DD MMMM HH:mm') {
      return formatDate(date, format = 'DD MMMM HH:mm')
    },
    async getChildren (offer) {
      if (!offer) {
        return []
      }

      const laborerList = {}
      for (const respond of offer.respondList) {
        if (respond && respond.laborer) {
          laborerList[respond.laborer.id] = respond.laborer
        }
      }
      return [
        ...offer.relayList.map((item) => ({ ...item, type: 'Смена', laborer: laborerList[item.laborer] })),
        ...offer.invitationList.map((item) => ({ ...item, type: 'Приглашение', laborer: laborerList[item.laborer] })),
        ...offer.respondList.map((item) => ({ ...item, type: 'Отклик' })),
      ]
    },
  }
}
</script>
